module.exports = __webpack_public_path__ + "img/vk.56d91b03.png";